<template>
<div id="showresponsecode" style="width: 421px !important; height: 254px !important;">
    <!-- RESPONES -->
    <div class="language-response extra-class" style="border-radius: 6px !important; background: #2A343A;">
        <div style="text-align: left; padding: 0px 16px 0px 16px; border: 1px solid #6D7278; height: 35px !important; display: flex; text-align-center; align-items: center; border-radius: 6px 6px 0px 0px;">
            <!-- <Dropdown v-model="selectedCity" :options="cities" optionLabel="name" placeholder="# Nombre librería" style="background: #2A343A; border: 0px; color: #C4C4C4 !important; top: -15px; height: 30px;" class="p-dropdown-label-1"/> -->
            <!-- <i class="pi icon-technical-expand" style="width: 14px; height: 20px; background: #C4C4C4; margin-right: 16px; cursor: pointer;" :style="{'rotate': !openCard ? '180deg' : ''}" @click="handleHeight()"/>
            <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer;" @click="CopyToClipboard('div1')" /> -->
            <span style="
                font-size: 14px;
                font-weight: 600;
                letter-spacing: -0.2px;
                color: #C4C4C4;
                font-family: var(--font-acumin-pro-semibold);
                top: 1px;
                position: relative;
            ">
                Response
            </span>
        </div>
        <div id="div1">
            <slot></slot>
        </div>
        <!-- <pre class="language-js code-copy-added" style="height: 254px; border-radius: 6px;">
            <code id="div1">
            <span class="token keyword">function</span> <span class="token function">doSum</span><span class="token punctuation">(</span><span class="token parameter">x<span class="token punctuation">,</span> y <span class="token punctuation">,</span> z</span><span class="token punctuation">)</span><span class="token punctuation">{</span>
                console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token string">"The sum is "</span><span class="token punctuation">)</span>
                console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span>x<span class="token operator">+</span>y<span class="token operator">+</span>z<span class="token punctuation">)</span>
                console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token string">"The average is: "</span><span class="token punctuation">)</span>
                console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">(</span><span class="token punctuation">(</span>x<span class="token operator">+</span>y<span class="token operator">+</span>z<span class="token punctuation">)</span><span class="token operator">/</span><span class="token number">3</span><span class="token punctuation">)</span>
            <span class="token punctuation">}</span>

            <span class="token comment">//function call</span>
            <span class="token function">doSum</span><span class="token punctuation">(</span><span class="token number">10</span><span class="token punctuation">,</span> <span class="token number">20</span><span class="token punctuation">,</span> <span class="token number">30</span><span class="token punctuation">)</span>
            </code>
        </pre> -->
        <div style="border: 1px solid #6D7278; height: 37px !important; text-align: left">
            <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer; margin: 7px 16px 7px 16px;" @click="CopyToClipboard('div1')" />
        </div>
    </div>
</div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
export default {
    name: 'ShowCode',
    components: { Dropdown },
    data: () => {
        return {
            selectedCity: null,
            cities: []
        }
    }
}
</script>
#showresponsecode {
    pre, pre[class*="language-"] {
        height: 182px !important;
        border-radius: 0px !important;
    }
}
<style>
</style>
